export const tooltips: Record<string, string> = {
  saved: 'Changes saved',
  saving: 'Saving...',
  offline: 'You’re offline. We’ll sync changes when you’re back.',
};
